import React, { useEffect } from 'react'
import { Row, Col, Label } from 'reactstrap'
import { dialogTypes } from 'decorators'
import MuiButton from '@material-ui/core/Button'
import { Button, ConfirmButton } from 'components/buttons'
import { format } from 'utils/stringUtilities'
import { Icon } from 'components/icons'
import { Input } from 'components/inputs'
import { ValidationBoundary, ValidationResult, Validator } from 'components/validation'
import { updateEntity } from 'utils/updateEntity'
import { FilterItem } from './item'
import { createDto } from './_helpers'

export const FiltersForm = ({ id, save, get, deleteFilter, page, classes, localize, addColumn, removeColumn, update, updateColumn, load, applyFilter, clearFilters, bottlesFilter, staticFilters, showDialog, availableColumns }) => {
  useEffect(() => { load(id) }, [id, load])
  const handleAddClick = React.useCallback(() => {
    showDialog({
      dialogType: dialogTypes.addFilter,
      context: {
        existingColumns: bottlesFilter.entity.columns,
        onSave: ({ column }) => addColumn(column.id),
        availableColumns
      }
    })
  }, [showDialog, addColumn, bottlesFilter.entity.columns, availableColumns])
  const handleClearClick = React.useCallback(() => clearFilters(), [clearFilters])
  const handleRemove = React.useCallback(index => removeColumn(index), [removeColumn])
  const handleApplyFilter = React.useCallback(() => applyFilter(bottlesFilter.entity.columns), [applyFilter, bottlesFilter.entity.columns])
  const handleSaveFilter = React.useCallback(() => {
    save(createDto(id, page, bottlesFilter.entity), () => get(page))
  }, [bottlesFilter.entity, save, get, id, page])

  const handleDeleteClick = React.useCallback(() => {
    deleteFilter({ id }, () => get(page))
  }, [id, deleteFilter, get, page])

  const { entity } = bottlesFilter
  const canAdd = entity.columns.length < availableColumns.length
  return (
    <ValidationBoundary>
      <Row>
        <Col sm={4}>
          <Label>{localize('common.title')}</Label>
          <Validator name='name' value={entity.title} required maxLength={100}>
            <Input value={entity.title} onChange={updateEntity('title', { update })} />
          </Validator>
        </Col>
        <Col sm={4}>
          <Label>{localize('common.order')}</Label>
          <Validator name='order' value={entity.order} required>
            <Input isNumeric value={entity.order} onChange={updateEntity('order', { update })} />
          </Validator>
        </Col>
      </Row>
      <Row>
        <Col>
          <Label>{localize('filters.title')}</Label>
          <div className={classes.root}>
            <div className={classes.buttons}>
              <MuiButton
                className={classes.addButton}
                variant='contained'
                title={localize('filters.add')}
                color='primary'
                disabled={!canAdd}
                onClick={handleAddClick}><Icon name={'plus'} /></MuiButton>
              <MuiButton
                className={classes.clearButton}
                variant='contained'
                title={localize('filters.clear')}
                color='primary'
                onClick={handleClearClick}><Icon name={'eraser'} /></MuiButton>
            </div>
            <div className={classes.filters}>
              {entity.columns.map((x, idx) => <FilterItem
                  key={idx}
                  column={x}
                  index={idx}
                  localize={localize}
                  onRemove={handleRemove}
                  update={updateColumn}
                  classes={classes}
                  availableColumns={availableColumns}
                  />)}
            </div>
          </div>
          <div className={classes.applyButton}>
            <Button width={200} icon='filter' onClick={handleApplyFilter}>{localize('filters.apply')}</Button>
            <ValidationResult render={({ isValid }) =>
              <Button disabled={!isValid || !entity.isDirty || staticFilters.saving} isLoading={staticFilters.saving} width={200} icon='save' onClick={handleSaveFilter}>{localize('common.save')}</Button>}
            />
            {id > 0 && <ConfirmButton width={200} icon='trash' color='secondary' confirmMessage={format(localize('filters.confirmDelete'), entity.title)} onConfirm={handleDeleteClick}>{localize('common.delete')}</ConfirmButton>}
          </div>
        </Col>
      </Row>
      <Row><Col><hr /></Col></Row>
    </ValidationBoundary>
  )
}
